export class LoginModel {
  email: string = '';
  password: string = '';
  userId: number = 0;
  fullName: string = '';
  msg: string = '';
  userRole: string = '';
  companyID: number = 0;
  company: string = '';
  userName: string = '';
  token: string = '';
  storeID: number = 0;
  ipAddress: string = '';
  accessRoleID: number = 0;
  productionAutoPrint: boolean = true;
  productionStayScreen: boolean = true;
  printPreview: boolean = false;
  isEnableSubcategory: boolean = false;
  isOPtionLock: boolean = false;
  isHidePricing: boolean = false;
  productionCycleColor: string = '';
  productionCycle: string = '';
  isNewUser: boolean = false;
  displayName: string = '';
  profileImgUrl: string = '';
  appID: number = 0;
  isActive: boolean = true;
  defaultModuleID: number = 0;
  outletID: number = 0;

  getLoginPayload() {
    return {
      userName: this.email,
      password: this.password,
    };
  }
}

export class Signout {
  userId: any;
  sessionId: any;
}

export interface LoginPayload {
  userName: string;
  password: string;
}

export class ProductImageResponse {
  id: number = 0;
  productId: number = 0;
  isPrimary: boolean = false;
  blobFileId: number = 0;
  url: string = '';
}

export class ConfirmEmail {
  token: string = '';
  email: string = '';
}

export class UserPermissions {
  id: number = 0;
  name: string = '';
  appId: number = 0;
  permissions: Array<Permission> = [];
}

export class Permission {
  id: number = 0;
  name: string = '';
}
interface AppVersionInfo {
  version: string;
  lastUpdated: string;
  url: string;
}

export class UserDetails {
  companyid: string = '0';
  email: string = '';
  exp: number = 0;
  fullname: string = '';
  iat: number = 0;
  iss: string = '';
  mustchangepasswordonlogin: string = '';
  nbf: number = 0;
  phonenumber: string = '';
  role: string = '';
  sub: string = '0';
  userid: string = '0';
}
export class AppDropdownModel {
  id: number = 0;
  name: string = '';
  storeAppId?: number = 0;
}
export class LookupModel {
  name: string = '';
  items: LookupItemsModel[] = [];
}
export class LookupItemsModel {
  id: number = 0;
  name: string = '';
}
export class CompanyModel {
  id: number = 0;
  name: string = '';
  status: number = 0;
  code: string = '';
  email: string = '';
  phoneNumber: string = '';
  website: string = '';
  logoUrl: string = '';
  businessTypeId: number = 0;
  teamSizeId: number = 0;
  currency: string = '';
  userTimeoutInMin: number = 0;
  showPrintPreview: boolean = false;
  inProduction: boolean = false;
  isMultipleStore: boolean = false;
  isBypassLicenses: boolean = false;
  isEnableSubcategory: boolean = false;
  primaryContact: PrimaryContact = new PrimaryContact();
  address: Address = new Address();
}
export class PrimaryContact {
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phoneNumber: string = '';
}
export class Address {
  line1: string = '';
  line2: string = '';
  city: string = '';
  zipCode: string = '';
  stateName: string = '';
  countryName: string = '';
  latitude: number = 0;
  longitude: number = 0;
  type: number = 0;
}
export class CountryModel {
  id: number = 0;
  name: string = '';
  fullName: string = '';
  code: string = '';
  currency: string = '';
  currencySymbol: string = '';
  continent: string = '';
  flagUrl: string = '';
}

export class StateModel {
  id: number = 0;
  name: string = '';
  code: string = '';
}

export class CompanyAppsModel {
  id: number = 0;
  apps: {
    id: number;
    name: string;
    roles: any[];
  }[] = [];
}

export class TimezoneModel {
  id: number = 0;
  name: string = '';
  abbreviation: string = '';
  code: string = '';
  standardUtcOffsetHours: number = 0;
  daylightUtcOffsetHours: number = 0;
  observesDaylightSaving: boolean = true;
  countryId: number = 0;
}
export class NamedResponse {
  id: number = 0;
  name: string = '';
}
export class WarehouseLocationLiteResponse{
  id: number = 0;
  name: string = '';
  warehouse:NamedResponse={
    id: 0,
    name: ''
  };
}
export class CompanyApps {
  id: number = 0;
  apps: NamedResponse[] = [];
}
export class RumSettings {
  companyId: number = 0;
  enableRumForTpmApp: boolean = false;
  enableRumForPosApp: boolean = false;
  enableRumForListerApp: boolean = false;
  enableRumForCompanyApp: boolean = false;
  id: number = 0;
}

export enum BulkUploadEntityType {
  Department = 1,
  Category = 2,
}

export enum BulkUploadStatus {
  Success = 0,
  Failed = 1,
}

export interface BulkUploadIconItemResult {
  rowNumber: number;
  entityName: string;
  iconFileName: string;
  status: BulkUploadStatus;
  errorMessage?: string;
  blobFileId?: number;
}

export interface BulkUploadIconsResponse {
  entityType: string;
  totalRows: number;
  processedRows: number;
  successfulRows: number;
  failedRows: number;
  items: BulkUploadIconItemResult[];
}
